export const STORE_UNAVAILABLE_ROUTE = "/store/errortienda";

/** Mensajes exactos que envía el API (y variantes sin punto final). */
export const STORE_UNAVAILABLE_MESSAGES = new Set([
  "Tienda no encontrada.",
  "Tienda no encontrada",
  "Tienda no disponible.",
  "Tienda inválida.",
  "Error resolviendo tienda.",
  "No se pudo resolver la tienda.",
  "No se pudo resolver la tienda para la petición.",
  "No se pudo resolver la tienda desde el dominio.",
  "No se pudo resolver la tienda desde el dominio",
]);

export function isStoreUnavailableMessage(msg) {
  if (typeof msg !== "string") return false;
  const t = msg.trim();
  if (STORE_UNAVAILABLE_MESSAGES.has(t)) return true;
  // Cubre el resto de variantes del backend ("…desde el dominio.", "…para la petición", etc.)
  if (/^No se pudo resolver la tienda\b/i.test(t)) return true;
  if (/^Tienda no encontrada\.?$/i.test(t)) return true;
  if (/^Tienda no disponible\.?$/i.test(t)) return true;
  return false;
}

export function isStoreUnavailableError(err) {
  const fromData = err?.data?.message;
  const fromAxios = err?.response?.data?.message;
  const plain = err?.message;

  return (
    isStoreUnavailableMessage(fromData) ||
    isStoreUnavailableMessage(fromAxios) ||
    isStoreUnavailableMessage(plain)
  );
}

export function shouldRedirectStoreUnavailable() {
  const path = window.location.pathname || "";
  if (path === STORE_UNAVAILABLE_ROUTE) return false;
  if (path !== "/store" && !path.startsWith("/store/")) return false;
  return true;
}

/** Redirección usada por los interceptores axios de la tienda (apiPublic / apiUserTienda). */
export function redirectIfStoreUnavailableMessage(message) {
  if (
    shouldRedirectStoreUnavailable() &&
    message &&
    isStoreUnavailableMessage(message)
  ) {
    window.location.replace(
      `${window.location.origin}${STORE_UNAVAILABLE_ROUTE}`
    );
  }
}